import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/scenes/{id}/shots — shots for a scene. */
export function useSceneShots(sceneId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.sceneShots(sceneId),
    queryFn: ({ signal }) => apiGet(`/scenes/${sceneId}/shots`, signal),
    enabled: !!sceneId && (enabled ?? true),
    ...rest,
  });
}
